import axios from 'axios'
const instance = axios.create({
    timeout: 50000,
    baseURL: 'https://api.siggraph.cn/'
});
// 添加请求拦截器
instance.interceptors.request.use(
    (request) => {
        request.headers["accept"] = "application/json";
        request.headers["Content-Type"] = "application/json";
        return request;
    },
    (error) => {
        return Promise.reject(error);
    }
);
// 添加响应拦截器
instance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        const response = error.response;
        if (!response.config.headers.nr) {
            switch (response ?.status) {
                case 401:
                    break;
                default:
                    break;
            }
        }
        return Promise.reject(response);
    }
);
export default instance;